.root {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}

.button {
    composes: button from "../../styles/buttons.module.scss";
    transform: translateY(-50%);
    z-index: 10;
}

.fineprint {
    bottom: 65px;
    z-index: 10;
}
